/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  emulator: {
    host: 'localhost',
    authPort: 9099,
    firestorePort: 8001,
    functionsPort: 5001,
  },
  emulatorEnabled: false,
  firebase: {
    apiKey: 'AIzaSyCBN54Y5xm2heaKYpWUUJoOPjXuylpY5YQ',
    authDomain: 'project-gavesha-test.firebaseapp.com',
    databaseURL: 'https://project-gavesha-test.firebaseio.com',
    projectId: 'project-gavesha-test',
    storageBucket: 'project-gavesha-test.appspot.com',
    messagingSenderId: '597670649598',
    appId: '1:597670649598:web:f9dfb3ac00b333bcf30faf',
    measurementId: 'G-SE1EY08M5L',
  },
  hostingAppDomain: 'https://project-gavesha-test.web.app',
  version: require('../../package.json').version,
};
